// Full menu — keep dish names in Spanish for authenticity
// Each price is a string with optional unit suffix (e.g. "S/M", "/PAX")

export const MENU = [
  {
    id: "ibericos",
    image:
      "https://customer-assets.emergentagent.com/job_corte-tradicional/artifacts/qhzgpvw1_Raul-y-Isabel.jpg",
    items: [
      { name: "Jamón de bellota", half: "10,00 €", full: "18,00 €" },
      { name: "Lomito de bellota", half: "12,00 €", full: "16,00 €" },
      { name: "Queso puro de oveja", half: "10,00 €", full: "14,00 €" },
      { name: "Queso de cabra", half: "8,00 €", full: "12,00 €" },
      { name: "Tabla serrana (jamón, queso y lomito)", half: null, full: "42,00 €" },
    ],
  },
  {
    id: "picar",
    image:
      "https://customer-assets.emergentagent.com/job_corte-tradicional/artifacts/451sawbv_67abf93c-d078-4abb-a98a-b7d56241b88b.jpg",
    items: [
      { name: "Patatas a la sanluqueña", half: "7,00 €", full: "10,00 €" },
      { name: "Ensaladilla crujiente", half: "8,00 €", full: "12,00 €" },
      { name: "Croquetas de jamón", half: "10,00 €", full: "15,00 €" },
      { name: "Fajita de camarón", half: null, full: "5,50 €" },
      { name: "Tortillita de camarón casera", half: null, full: "4,50 €" },
      { name: "Ensalada de queso de cabra", half: null, full: "12,00 €" },
      { name: "Ensalada mixta", half: "8,00 €", full: "10,00 €" },
      { name: "Aliño de pimientos asados", half: "7,00 €", full: "10,00 €" },
    ],
  },
  {
    id: "sugerencias",
    image:
      "https://customer-assets.emergentagent.com/job_corte-tradicional/artifacts/30goqe4k_4187bb32-94d5-4add-b338-415436ab4b55.jpg",
    items: [
      { name: "Gulas al ajillo con langostinos y huevo", half: null, full: "15,00 €" },
      { name: "Huevos rotos con jamón", half: null, full: "14,00 €" },
      { name: "Revuelto de langostinos y jamón", half: null, full: "15,00 €" },
      { name: "Pulpo con puré de patatas", half: null, full: "22,00 €" },
      { name: "Taco mexicano de atún rojo", half: null, full: "6,00 €" },
      { name: "Tomate rosa con melva", half: null, full: "12,00 €" },
      { name: "Salmorejo con guarnición", half: null, full: "9,00 €" },
      { name: "Carrillera ibérica en salsa", half: "10,00 €", full: "15,00 €" },
      { name: "Salsa de tomate casero con delicias de bacalao", half: null, full: "18,00 €" },
      { name: "Patatas de verano con huevo", half: null, full: "15,00 €" },
    ],
  },
  {
    id: "arroces",
    image:
      "https://images.unsplash.com/photo-1534080564583-6be75777b70a?auto=format&fit=crop&w=1200&q=80",
    note: "Precio por persona (mínimo 2 pax)",
    items: [
      { name: "Arroz ibérico", half: null, full: "18,00 € / pax" },
      { name: "Arroz negro con alioli", half: null, full: "18,00 € / pax" },
      { name: "Arroz caldoso de marisco", half: null, full: "18,00 € / pax" },
      { name: "Arroz meloso de presa ibérica", half: null, full: "20,00 € / pax" },
    ],
  },
  {
    id: "carnes",
    image:
      "https://customer-assets.emergentagent.com/job_corte-tradicional/artifacts/miv2k28o_6fc711c5-e9d8-4827-81e0-3c68e8439f35.jpg",
    items: [
      { name: "Presa ibérica de bellota", half: "12,00 €", full: "22,00 €" },
      { name: "Lagartito ibérico de bellota", half: "10,00 €", full: "18,00 €" },
      { name: "Solomillo ibérico de bellota", half: null, full: "20,00 €" },
      { name: "Secreto ibérico de bellota", half: null, full: "18,00 €" },
    ],
  },
  {
    id: "pescados",
    image:
      "https://customer-assets.emergentagent.com/job_corte-tradicional/artifacts/vl4gyivz_3191ffe1-5a09-4649-a148-acec9456ae35.jpg",
    items: [
      { name: "Pez espada a la plancha", half: null, full: "18,00 €" },
      { name: "Ventresca de atún rojo de almadraba", half: null, full: "25,00 €" },
      { name: "Tarantelo de atún rojo de almadraba", half: null, full: "22,00 €" },
      { name: "Calamar de potera plancha o frito", half: null, full: "S/M" },
      { name: "Acedías de trasmallo fritas", half: "8,00 €", full: "15,00 €" },
      { name: "Choco frito", half: "8,00 €", full: "14,00 €" },
      { name: "Pijotas de isla", half: "10,00 €", full: "15,00 €" },
    ],
  },
];
